import { motion } from "framer-motion";
import { CalendarDays, Palmtree } from "lucide-react";
import { BRAND, DIVISION, TAGLINE } from "@/content";

const fade = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: "easeOut" },
});

export default function Hero({ onBook }) {
  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden">
      <img
        src="/images/hero-bali.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-35"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#12281D]/70 via-[#1B3B2B]/85 to-[#12281D]" />
      <div className="relative mx-auto max-w-6xl px-5 pt-32 pb-16 lg:pt-44 lg:pb-28 grid lg:grid-cols-[1.15fr_0.85fr] gap-14 items-center">
        <div>
          <motion.p {...fade(0.05)} className="overline-gold mb-6" data-testid="hero-division-badge">
            {DIVISION}
          </motion.p>
          <motion.p {...fade(0.15)} className="font-script text-3xl sm:text-4xl text-[#D4AF37] mb-2">
            Meet
          </motion.p>
          <motion.h1
            {...fade(0.25)}
            data-testid="hero-brand-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#FBF9F1]"
          >
            Shawnie &amp; Aunnie
            <br />
            <span className="gold-text">Presents...</span>
          </motion.h1>
          <motion.p
            {...fade(0.35)}
            data-testid="hero-tagline"
            className="mt-6 text-base sm:text-lg text-[#D1DDD5] leading-relaxed max-w-xl"
          >
            {TAGLINE} — curated by two lifelong friends who turned shared loss into sacred,
            unforgettable experiences.
          </motion.p>
          <motion.div {...fade(0.45)} className="mt-9 flex flex-col sm:flex-row gap-4">
            <button data-testid="book-discovery-call-button" onClick={onBook} className="btn-gold">
              <CalendarDays size={16} />
              Book a Discovery Call
            </button>
            <a data-testid="hero-explore-retreat-button" href="#retreat" className="btn-outline-cream">
              <Palmtree size={16} />
              Explore Bali 2026
            </a>
          </motion.div>
          <motion.div
            {...fade(0.55)}
            data-testid="hero-stats-pillbar"
            className="mt-10 flex flex-wrap gap-2.5"
          >
            {["55+ Yrs in Business", "30+ Countries", "Traveled with Oprah 2x"].map((pill) => (
              <span
                key={pill}
                className="rounded-full border border-[#D4AF37]/30 bg-[#1B3B2B]/60 px-4 py-1.5 text-[11px] uppercase tracking-[0.18em] text-[#EED88F]"
              >
                {pill}
              </span>
            ))}
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
          className="relative mx-auto w-full max-w-sm lg:max-w-none"
        >
          <div className="gold-frame rounded-[2rem] overflow-hidden rotate-1">
            <img
              src="/images/founders.jpg"
              alt="Shawnie Bailey and Aunnie Williamson at one of their styled gatherings"
              data-testid="hero-founders-portrait"
              className="w-full h-[420px] sm:h-[500px] object-cover object-top"
            />
          </div>
          <p className="mt-5 text-center font-script text-2xl text-[#D4AF37]">
            Shawnie &amp; Aunnie
          </p>
          <p className="text-center text-[11px] uppercase tracking-[0.25em] text-[#FBF9F1]/50 mt-1">
            Founders &amp; Sisters at Heart
          </p>
        </motion.div>
      </div>
    </section>
  );
}
